<template>
  <div class="box__buy">
    <ShopItemBuyCurrency
      v-if="!isBoxForVictory"
      :boxContent="boxContent"
      :currentCurrency="active_currency"
      :currentBoxes="opened_box"
      @changeCurrency="changeCurrency"
    />

    <ShopItemBuyVictory v-else :boxContent="boxContent" :victoryCurrency="currency" />

    <ShopItemBuyButtons
      :boxContent="boxContent"
      :currentCurrency="active_currency"
      :victoryCurrency="currency"
      :isBoxForVictory="isBoxForVictory"
      @countBox="changeCount"
      @openBoxGTM="openBoxGTM"
    />
  </div>
</template>
<script>
import ShopItemBuyCurrency from "./ShopItemBuyCurrency";
import ShopItemBuyVictory from "./ShopItemBuyVictory";
import ShopItemBuyButtons from "./ShopItemBuyButtons";

export default {
  name: "ShopItemBuy",
  components: {
    ShopItemBuyCurrency,
    ShopItemBuyVictory,
    ShopItemBuyButtons,
  },
  props: {
    boxContent: Object,
    isBoxForVictory: Boolean,
    currency: String,
  },
  data() {
    return {
      active_currency: "soft",
      opened_box: 1,
    };
  },
  methods: {
    changeCurrency(type) {
      this.active_currency = type;
    },
    changeCount(new_count) {
      this.opened_box = new_count;
    },
    openBoxGTM(currency) {
      this.$emit("openBoxGTM", currency);
    },
  },
};
</script>
